import * as Sentry from '@sentry/react';

import { environment } from '@doger/core/shared/config';

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: environment.sentry.dsn,
    environment: environment.sentry.environment,
    release: environment.sentry.release,
    integrations: [
      Sentry.replayIntegration(),
      Sentry.browserSessionIntegration(),
      Sentry.captureConsoleIntegration({
        levels: ['error', 'warn'],
      }),
      Sentry.extraErrorDataIntegration(),
      Sentry.httpClientIntegration({
        failedRequestStatusCodes: [
          ...Array.from({ length: 99 })
            .map((_, index) => index + 400)
            .filter((statusCode) => statusCode !== 401 && statusCode !== 403),

          ...Array.from({ length: 99 }).map((_, index) => index + 500),
        ],
      }),
      Sentry.zodErrorsIntegration(),
    ],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.,

    // Enable logs to be sent to Sentry
    enableLogs: true,

    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
  });
}
